<template>
  <Card class="comments" :title="!$slots.header ? $tc('message', 2) : null" v-bind="$attrs">
    <template #header> <slot name="header" /> </template>
    <template #default>
      <div class="comments__list" ref="list">
        <Item v-for="item in items" :key="item.id" :value="item" />
        <div v-if="!items.length" class="fade my-2">{{ $t('noMessages') }}</div>
      </div>
    </template>
    <template #footer>
      <CommentInput v-if="!readonly" v-on="$listeners" :promise="promise" v-bind="$attrs">
        <template #before>
          <slot name="before-input" />
        </template>
        <template #after>
          <slot name="after-input" />
        </template>
      </CommentInput>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import CommentInput from '@/components/Comment/Input'
import Item from './Item'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    title: String,
    scope: String,
    promise: Promise,
    readonly: Boolean,
  },
  provide() {
    return {
      scope: this.scope,
    }
  },
  watch: {
    value: {
      handler: 'scrollToEnd',
      immediate: true,
    },
  },
  computed: {
    items() {
      return this.value.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
    },
  },
  methods: {
    scrollToEnd() {
      if (!this.$refs.list) return
      this.$refs.list.scrollTop = this.$refs.list.scrollHeight
    },
  },
  components: {
    Item,
    Card,
    CommentInput,
  },
}
</script>

<style lang="scss">
.comments {
  &__list {
    max-height: 750px;
    min-height: 400px;
    overflow-y: auto;

    margin-top: 1rem;

    & > * + * {
      margin-top: 1.5rem;
    }
  }

  & > .card__footer {
    & > .card__footer-content {
      flex-direction: column;
    }
  }

  .comment-input {
    flex-grow: 1;
  }
}
</style>
